"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import MedicalContentSection from "@/components/molecules/medical-section/medical-content-section";
import { QuoteDecline } from "@/config/app-constant";
import { useLoading } from "@/providers/loading-provider";
import { MedicalDeclineContentType } from "@/utils/schema/quote-decline-schema.utils";

import Styles from "./medicalSection.module.css";

type QuoteDeclineProps = {
  unableToQuoteContent: MedicalDeclineContentType | null;
};

function MedicalDeclineSection({
  unableToQuoteContent,
}: Readonly<QuoteDeclineProps>) {
  const router = useRouter();
  const [pageLoad, setPageLoad] = useState(false);
  const { hideLoading } = useLoading();

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      sessionStorage.getItem("PageReloadMedical") === "true"
    ) {
      history.pushState(null, "", location.href);
      window.onpopstate = function f() {
        const stringWithoutSlashes = window.location.pathname.replace(
          /\//g,
          ""
        );
        if (
          stringWithoutSlashes === QuoteDecline &&
          sessionStorage.getItem("PageReloadMedical") === "true"
        ) {
          history.go(1);
        } else {
          window.onpopstate = null;
          history.back();
        }
      };
    }
  }, []);

  useEffect(() => {
    setPageLoad(true);
    if (pageLoad) {
      if (sessionStorage.getItem("PageReloadMedical") === "true") {
        sessionStorage.setItem("PageReloadMedical", "false");
        router.push("/");
      } else {
        sessionStorage.setItem("PageReloadMedical", "true");
      }
      hideLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLoad]);

  if (!unableToQuoteContent) {
    return null;
  }

  const { declinedTitle, declinedContent } = unableToQuoteContent;

  const renderMedicalContentSection = () => {
    return (
      <MedicalContentSection
        titleRiskLevel={declinedTitle}
        className="lg:ml-[37px]"
        travelEligibilityContent={declinedContent}
        linkText=""
      />
    );
  };

  return (
    <div
      className={` ${Styles.grid_block} grid md:grid-cols-12 grid-cols-6 gap-spacing-l xl:mx-auto lg:mx-[72px] md:mx-[48px] mx-[24px] !h-full relative`}
    >
      <div className={`${Styles.question_layout_wrapper} col-span-12`}>
        <div
          className={` ${Styles.question_layout} bg-dark-surface-accent-1-primary text-surface-neutral-option-2 rounded-radius-xxl relative`}
        >
          <div
            className={` ${Styles.content_box}  md:pt-spacing-xl py-spacing-xs px-spacing-m flex flex-col items-center w-full`}
          >
            {renderMedicalContentSection()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicalDeclineSection;
